import { MapObject } from "./map-object";

export class Image extends MapObject {
    
    constructor(public id:number, public longitude:number, public latitude:number, public altitude:number,
        public title:String, public description:String, public datetime:String, public fkAlbum:String
    ) {
        super(id, longitude, latitude, title)
    }

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/shared/data/image.ts